import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20luxurious%20dark%20gaming%20entertainment%20background%20with%20warm%20golden%20geometric%20patterns%20and%20soft%20glowing%20particles%2C%20elegant%20premium%20atmosphere%2C%20dark%20navy%20with%20amber%20gold%20accents%2C%20sophisticated%20abstract%20design%2C%20smooth%20gradients&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="2pg·com 游戏平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-5 leading-tight">
            {heroData.headline}
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 leading-relaxed max-w-2xl mx-auto">
            {heroData.subheadline}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/about"
              className="inline-flex items-center px-8 py-3.5 rounded-full text-base font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              {heroData.ctaPrimary}
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center px-8 py-3.5 rounded-full text-base font-medium border border-white/30 text-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
            >
              {heroData.ctaSecondary}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}